// extracted by mini-css-extract-plugin
export default {"container":"Products_container__21XCh","products":"Products_products__Gq235","menu":"Products_menu__LYwzf","list":"Products_list__L8FFY","product":"Products_product__m3-Na"};